import React, { useState } from 'react'
import { LoginForm } from '../LoginForm/LoginForm'
import { SignUpForm } from '../SignUpForm/SignUpForm'
import { PageContainer, Logo, Footer, FooterLinks, FooterLink } from './styled'

const AuthPage: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true)

  const toggleMode = () => {
    setIsLogin(!isLogin)
  }

  return (
    <PageContainer>
      <Logo>QuickCasa Waypoint</Logo>
      {isLogin ? (
        <LoginForm onToggleMode={toggleMode} />
      ) : (
        <SignUpForm onToggleMode={toggleMode} />
      )}
      <Footer>
        <FooterLinks>
          <FooterLink href="/terms" target="_blank">
            Terms of Use
          </FooterLink>
          <span>•</span>
          <FooterLink href="/privacy" target="_blank">
            Privacy Policy
          </FooterLink>
        </FooterLinks>
      </Footer>
    </PageContainer>
  )
}

export { AuthPage }
